export enum ECreditType {
  New_Customer,
  Referral,
}
